import { colors } from '../../colors';
var fiveCard = {
  textColor: colors.white,
  hoverColor: colors.pumpkinOrange,
  bgColorPara: colors.black,
  bgColor: colors.white,
  cardBgColorB: colors.white,
  cardBgColorHoverB: colors.deepOrange,
  cardCTAColorB: colors.black,
  cardCTAColorHoverB: colors.white,
  textBgOpacity: '0.5',
  iconColor: colors.deepOrange,
  iconColorHover: colors.white,
  textBGWidthFull: true
};
export default fiveCard;